module.exports = __webpack_public_path__ + "media/assets/images/blog/DALL·E_voice_bot-033bf280cb081f44d74ed192ef4a24bc.png";